import Meta from '@/components/common/Meta'

import SummerStorageForCollegeStudentsPage from '@/v2/components/pages/template-landing-pages/summer-storage-for-college-students-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/summer-storage-for-college-students-page'

interface SummerStorageForCollegeStudentsPageProps {}

const Page: React.FC<SummerStorageForCollegeStudentsPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.summer_storage_for_college_students.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.summer_storage_for_college_students?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.summer_storage_for_college_students?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <SummerStorageForCollegeStudentsPage />
    </>
  )
}

export default Page
